import { render, staticRenderFns } from "./AdminProjectLogDisputeList.vue?vue&type=template&id=29554e3b&scoped=true&"
import script from "./AdminProjectLogDisputeList.vue?vue&type=script&lang=js&"
export * from "./AdminProjectLogDisputeList.vue?vue&type=script&lang=js&"
import style0 from "./AdminProjectLogDisputeList.vue?vue&type=style&index=0&id=29554e3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29554e3b",
  null
  
)

export default component.exports